import {SheetSettingsController as BaseSheetSettingsController} from '@mintdata-wsp/common/controllers/spreadsheet/SheetSettingsController';
import {SheetSettings} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetSettings';
import {Sheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/Sheet';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {action} from 'mobx';
import {SheetSettingsId} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetSettingsTypes';

export class SheetSettingsController extends BaseSheetSettingsController
{
    @action
    public createSheetSettings(sheetId:SheetId):SheetSettings
    {
        const {main, workbook, tabs, frameDetails} = controllers.ui.spreadsheets;
        const sheet = main.findAnySheetById(sheetId, true) as Sheet;

        if( workbook.isTopLevelSheet(sheet.workbook.id, sheetId) )
        {
            const sheetSettings = this.getSheetSettings(sheetId) as SheetSettings | null;

            if( !sheetSettings )
            {
                const workbook = main.findWorkbookById(sheet.workbook.id);
                workbook.view.addSheetSettings(SheetSettings.create(sheetId, sheetId, null));

                return workbook.view.getSheetSettingsById(sheetId);
            }

            return sheetSettings;
        }

        const activeSheet = tabs.getActiveSheet(sheet.workbook.id);
        const frameDetailsEntry = frameDetails.getEntryBySheetId(sheet.workbook.id, activeSheet.id, sheetId);

        const sheetCtrl = workbook.getSheetCtrl(frameDetailsEntry.mainSheetId);

        const slot = sheetCtrl.findSlot(frameDetailsEntry.mainSheetId, frameDetailsEntry.mainSheetSlotLocation);
        const nestedFrameId = this.buildSheetSettingsIdBySlotId(slot.id, frameDetailsEntry.pathInFrame);
        const sheetSettings = this._getSheetSettings(nestedFrameId) as SheetSettings | null;

        if( !sheetSettings )
        {
            const workbook = main.findWorkbookById(frameDetailsEntry.workbookId);
            workbook.view.addSheetSettings(SheetSettings.create(nestedFrameId, frameDetailsEntry.mainSheetId, slot.id));

            return workbook.view.getSheetSettingsById(nestedFrameId);
        }

        return sheetSettings;
    }

    public buildSheetSettingsIdBySheetId(sheetId:SheetId):SheetSettingsId
    {
        const {main, workbook, tabs, frameDetails} = controllers.ui.spreadsheets;

        const sheet = main.findAnySheetById(sheetId, true) as Sheet;

        if( workbook.isTopLevelSheet(sheet.workbook.id, sheetId) )
            return sheetId;

        const activeSheet = tabs.getActiveSheet(sheet.workbook.id);
        const frameDetailsEntry = frameDetails.getEntryBySheetId(sheet.workbook.id, activeSheet.id, sheetId);

        const sheetCtrl = workbook.getSheetCtrl(frameDetailsEntry.mainSheetId);
        const slot = sheetCtrl.findSlot(frameDetailsEntry.mainSheetId, frameDetailsEntry.mainSheetSlotLocation);

        return this.buildSheetSettingsIdBySlotId(slot.id, frameDetailsEntry.pathInFrame);
    }

    protected _findAnySheetById(sheetId:SheetId):Sheet
    {
        const {main} = controllers.ui.spreadsheets;

        return main.findAnySheetById(sheetId, true) as Sheet;
    }
}
